import Ritten from './Ritten';
export default function App() { return <Ritten />; }
